/*
 * @Author: zhengxiaowen
 * @Date: 2018-08-24 23:55:07
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-13 01:33:19
 */


import platform from '@/config/platform'

let host = platform.host

let _srmServer = platform.url.srmServer
let _baseServer = platform.url.baseServer
let _cxfServer = platform.url.cxfServer
// PC移入
let hostname = window.location.hostname;
let bigFileHost = platform.bigFileHost;
let resourceServerName = "/resourceServer";
let projectClueServerName = "/projectClueServer";
let fileServerUrl = platform.url.fileServer;
let srmServerUrl = platform.url.srmServer;
let bpmServer = platform.url.bpmServer;

let api = {
    // 快码查询
    baseLookupTypeService_find: `${_baseServer}/baseLookupTypeService/find`,

    /**
     * 移动端登录及首页
     */
    //登录
    login: `${_baseServer}/baseLoginService/login`,
    //微信授权登录
    wechat_login: `${_srmServer}/v1/scsi/srmWechatAuthorization/login`,
    //飞书SSO登录
    feishu_login: `${_srmServer}/v1/scsi/srmFeishuAuthorization/login`,
    //企微授权登录
    wecom_getUserDetail: `${_cxfServer}/v1/scsi/wecom/getUserDetail`,
    //企业微信JSAPI签名
    wecom_getJsSdkSignature: `${_cxfServer}/v1/scsi/wecom/getJsSdkSignature`,
    //获取验证码
    generateRandomValidate: `${_baseServer}/baseLoginService/generateRandomValidate`,
    //数据字典快码查询
    baseLookupTypeService_findDic: `${_baseServer}/baseLookupValuesService/findDic`,
    //获取功能菜单(根据职责Id)
    findBaseMenuByRespId: `${_baseServer}/baseMenuService/findBaseMenuByRespId`,
    // 获取当前微信用户OpenID
    getWechatAuthorizeOpenId: `${_baseServer}/wxLoginService/wechat/web/authorize/openId`,
    //人员信息查询列表
    baseUsersService_findPagination: `${_baseServer}/baseUsersService/findPagination`,
    //根据token获取用户信息
    baseUsersService_getW3UserCode: `${_baseServer}/baseLoginService/getW3UserCode`,
    //根据bpmListId获取taskId
    baseUsersService_getTaskIdByBpmListId: `${_baseServer}/baseLoginService/getTaskIdByBpmListId`,

    /**
     * 供应商管理
     */
    //供应商待办列表查询
    srmMobileSupplierPendingRestful_listByPage: `${_srmServer}/v1/srmMobileSupplierPendingRestful/listByPage`,
    //供应商通知查询
    srmBaseNotificationRestful_listByPage: `${_srmServer}/v1/srmBaseNotificationRestful/listByPage`,
    /** 绩效结果（与 PC 一致） */
    srmSpePerformance_listByPage: `${srmServerUrl}/v1/srmSpePerformanceRestful/listByPage`,
    srmSpePerformance_findPerFormAnceVOById: `${srmServerUrl}/v1/srmSpePerformanceRestful/findPerFormAnceVOById`,
    //分页查询供应商的资料
    supplierInfoRestful_listByPage: `${_srmServer}/v1/srmSlcSupplierInfoRestful/listByPage`,

    /**
     *  内部待办表
     */
    interiorPending_listByPage: `${_srmServer}/v1/srmBaseInteriorPendingRestful/listByPage`,
    /* 根据KEY ID查询系统公告表 */
    notice_findById: `${_srmServer}/v1/srmBaseNoticeRestful/findById`,
    /*  分页查询系统公告表 */
    notice_listByPage: `${_srmServer}/v1/srmBaseNoticeRestful/listByPage`,
    /*  分页查询系统公告概要 */
    notice_listSummaryByPage: `${_srmServer}/v1/srmBaseNoticeRestful/listSummaryByPage`,

    /**
     * 寻源协同
     */
    //报价列表查看
    molieListByPage: `${_srmServer}/v1/srmSfdMobileRespondHeader/molieListByPage`,
    //报价参与或拒绝
    mobileSaveSupplierReply: `${_srmServer}/v1/srmSfdMobileRespondHeader/mobileSaveSupplierReply`,
    //投标（创建报价单）
    mobileCreateRespond: `${_srmServer}/v1/srmSfdMobileRespondHeader/mobileCreateRespond`,
    //报价编辑详情
    mobileFindById: `${_srmServer}/v1/srmSfdMobileRespondHeader/mobileFindById`,
    //报价编辑保存
    moblieSaveOrUpdate: `${_srmServer}/v1/srmSfdMobileRespondHeader/moblieSaveOrUpdate`,
    //报价编辑提交
    mobileDoSubmit: `${_srmServer}/v1/srmSfdMobileRespondHeader/mobileDoSubmit`,
    //上传附件接口
    fileUpload: `${fileServerUrl}/v2/file/upload`,
    //下载附件接口
    batchDownload: `${fileServerUrl}/v2/file/batchDownload`,
    //下载接口（获取下载文件url地址）
    getFileUrl: `${fileServerUrl}/v2/file/getFileUrl`,
    //v2文件多个文件打包下载服务
    v2ListBaseFile: `${fileServerUrl}/v2/file/listBaseFile`,
    //v2图片浏览
    v2ImagesPreview: `${fileServerUrl}/v2/images/preview`,
    //v2文件多个文件打包下载服务
    v2FileGetFileToBase64: `${fileServerUrl}/v2/file/getFileToBase64`,
    //v1超大文件下载服务,使用Body传参
    v2FileDownloadBody: `${fileServerUrl}/v2/file/downloadBody`,
    convertFile_baseFile2Pdf : `${fileServerUrl}/v2/convertFile/baseFile2Pdf`,//打开PDF文件流(Office文件转换为PDF)

    /**
     * 询价
     */
    //询价报价（询价报价列表查询）
    listByPageForBidToMobile: `${_srmServer}/v1/srmMobileInquiryRegistrationRestful/listByPageForBidToMobile`,
    //询价报价（询价报价-回应）
    doAnswerForSupp: `${_srmServer}/v1/srmMobileInquiryRegistrationRestful/doAnswerForSupp`,
    //询价报价（询价报价-拒绝）
    doRefuseForSupp: `${_srmServer}/v1/srmMobileInquiryRegistrationRestful/doRefuseForSupp`,

    /**
     * 订单协同
     */
    //客户订单（订单查询--按头信息查询数据）
    orderListByPage: `${_srmServer}/v1/srmMobileOrderHeaderRestful/listByPage`,
    //客户订单（订单确认--按物料查询明细）
    orderListByDetailPage: `${_srmServer}/v1/srmMobileOrderHeaderRestful/listByDetailPage`,
    //客户订单（详情头信息1）
    orderMobileFindById: `${_srmServer}/v1/srmMobileOrderHeaderRestful/mobileFindById`,
    //客户订单（详情行信息-物料2）
    orderListByPageLine: `${_srmServer}/v1/srmMobileOrderHeaderRestful/listByPageLine`,
    //客户订单（交期确认）
    doSupplierDeliveryConfirm: `${_srmServer}/v1/srmMobileOrderHeaderRestful/doSupplierDeliveryConfirm`,

    /**
     * 采购订单（PC purOrderHeaderList / purOrderHeaderEdit、purSupplierOrderList）
     */
    srmPurOrderHeader_listOrderByPage: `${srmServerUrl}/v1/srmPurOrderHeaderRestful/listOrderByPage`,
    srmPurOrderHeader_findById: `${srmServerUrl}/v1/srmPurOrderHeaderRestful/findById`,
    srmPurOrderLine_listByPage: `${srmServerUrl}/v1/srmPurOrderLineRestful/listByPage`,
    srmPurOrderHeader_doConfirmAndReject: `${srmServerUrl}/v1/srmPurOrderHeaderRestful/doConfirmAndReject`,
    srmPurPurchaseBillType_listByPage: `${srmServerUrl}/v1/srmPurPurchaseBillTypeRestful/listByPage`,

    /**
     * 询价报价（PC inquiryNotQuotationList / inquiryViewToSupplier / inquiryNotQuotationDetail）
     */
    auctionHeaderRestful_listByPageForBid: `${srmServerUrl}/v1/srmSfdAuctionHeaderRestful/listByPageForBid`,
    auctionSupplierRestful_listAuctionSupplier: `${srmServerUrl}/v1/srmSfdAuctionSupplierRestful/listAuctionSupplier`,
    auctionSupplierRestful_doAnswerForSupp: `${srmServerUrl}/v1/srmSfdAuctionSupplierRestful/doAnswerForSupp`,
    auctionSupplierRestful_doRefuseForSupp: `${srmServerUrl}/v1/srmSfdAuctionSupplierRestful/doRefuseForSupp`,
    auctionItemRestful_listAuctionItem: `${srmServerUrl}/v1/srmSfdAuctionItemRestful/listAuctionItem`,
    bidHeaderRestful_doCreateBid: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/doCreateBid`,
    bidHeaderRestful_doCreateBargaining: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/doCreateBargaining`,
    bidHeaderRestful_saveOrUpdate: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/saveOrUpdate`,
    bidHeaderRestful_doSubmit: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/doSubmit`,
    pay_list_listByPage: `${srmServerUrl}/v1/srmBasePaymentTermRestful/listByPage`,

    /**
     * 送货协同
     */
    //订单协同（送货通知单查询列表）
    listMobileDeliveryNotice: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/listMobileDeliveryNotice`,
    //订单协同（送货通知单查询头-详情1）
    noticeFindById: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/noticeFindById`,
    //订单协同（送货通知单查询行-详情2）
    listByPageToMobile: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/listByPageToMobile`,
    //订单协同（送货单查询列表-旧移动端接口，送货通知相关保留）
    listMobileDeliveryNote: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/listMobileDeliveryNote`,
    deliveryNoteHeader_findById: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/notefindById`,
    deliveryNoteLine_listLineByPage: `${_srmServer}/v1/srmMobileDeliveryNoticeRestful/listLineByPageToMobile`,
    /** 送货单（PC 接口，purDeliveryNoteList / purDeliveryNoteEdit） */
    srmPurDeliveryNoteHeader_listByPage: `${srmServerUrl}/v1/srmPurDeliveryNoteHeaderRestful/listByPage`,
    srmPurDeliveryNoteHeader_findById: `${srmServerUrl}/v1/srmPurDeliveryNoteHeaderRestful/findById`,
    srmPurDeliveryNoteLine_listByPage: `${srmServerUrl}/v1/srmPurDeliveryNoteLineRestful/listByPage`,
    /** 扫码绑定送货单 */
    srmPurLabelManage_findLabelForScanBind: `${srmServerUrl}/v1/srmPurLabelManageRestful/findLabelForScanBind`,
    srmPurLabelManage_doBindDeliveryNote: `${srmServerUrl}/v1/srmPurLabelManageRestful/doBindDeliveryNote`,
    srmPurLabelManage_doUnbindDeliveryNote: `${srmServerUrl}/v1/srmPurLabelManageRestful/doUnbindDeliveryNote`,
    /** 到料计划（PC 接口） */
    srmPurDeliveryNoticeHeader_findById: `${srmServerUrl}/v1/srmPurDeliveryNoticeHeaderRestful/findById`,
    srmPurDeliveryNoticeHeader_listByPage: `${srmServerUrl}/v1/srmPurDeliveryNoticeHeaderRestful/listByPage`,
    srmPurDeliveryNoticeHeader_saveOrUpdate: `${srmServerUrl}/v1/srmPurDeliveryNoticeHeaderRestful/saveOrUpdate`,
    srmPurDeliveryNoticeLine_listByPage: `${srmServerUrl}/v1/srmPurDeliveryNoticeLineRestful/listByPage`,
    srmPurDeliveryNoticeLine_listDeliveryNoticeByPage: `${srmServerUrl}/v1/srmPurDeliveryNoticeLineRestful/listDeliveryNoticeByPage`,
    srmPurDeliveryNoticeLine_listUsableDeliveryPoLineByPage: `${srmServerUrl}/v1/srmPurDeliveryNoticeLineRestful/listUsableDeliveryPoLineByPage`,
    srmPurDeliveryNoticeLine_doBatchDelete: `${srmServerUrl}/v1/srmPurDeliveryNoticeLineRestful/doBatchDelete`,
    srmPurDeliveryNoticeLine_doSupBatchConfirm: `${srmServerUrl}/v1/srmPurDeliveryNoticeLineRestful/doSupBatchConfirm`,
    srmPurDeliveryNoticeLine_doSupBatchRefuse: `${srmServerUrl}/v1/srmPurDeliveryNoticeLineRestful/doSupBatchRefuse`,
    baseOrganizationService_listBaseOrganizationByPermission: `${_baseServer}/baseOrganizationService/listBaseOrganizationByPermission`,
    baseOrganizationService_findDefaultOrgByPermission: `${_baseServer}/baseOrganizationService/findDefaultOrgByPermission`,

    /**
     * 微信公众号
     */
    //获取微信网页授权内容
    wechat_authorize: `${_srmServer}/v1/srmWechatAuthorization/authorize`,
    //微信授权获取openId
    wechat_userInfo: `${_srmServer}/v1/srmWechatAuthorization/userInfo`,
    //更新用户微信openId
    updateWxOpenIdById: `${_baseServer}/baseUsersService/updateWxOpenIdById`,
    //获取JS认证码
    wechatJsApiGenerateSignature: `${_baseServer}/wxLoginService/generate/jsapi/signature`,

    /* Begin 竞价单消息表 API列表 */
    competeHall_doCompeteHallTurnProcess: `${_srmServer}/v1/srmSfdCompeteHallRestful/doCompeteHallTurnProcess`, /*  启动、暂停竞价 */
    competeHall_doInitCacheSupplier: `${_srmServer}/v1/srmSfdCompeteHallRestful/doInitCacheSupplier`, /*  初始化供应商到缓存并生成随机编码 */
    competeHall_getCompeteSupplierInfo: `${_srmServer}/v1/srmSfdCompeteHallRestful/getCompeteSupplierInfo`, /*  从竞价供应商缓存查找供应商信息 */
    competeHall_doCacheSupplierReady: `${_srmServer}/v1/srmSfdCompeteHallRestful/doCacheSupplierReady`, /*  竞价供应商准备就绪状态更新 */
    competeHall_doSupplierOfferPrice: `${_srmServer}/v1/srmSfdCompeteHallRestful/doSupplierOfferPrice`, /* 供应商出价 */
    competeHall_listCacheNewestSupplierOfferItems: `${_srmServer}/v1/srmSfdCompeteHallRestful/listCacheNewestSupplierOfferItems`, /* 获取供应商最新报价物料信息  */
    competeHall_listCacheNewestCompeteOfferHeader: `${_srmServer}/v1/srmSfdCompeteHallRestful/listCacheNewestCompeteOfferHeader`, /* 查询查询所有供应商最新报价信息  */
    competeHall_doCloseCompeteHall: `${_srmServer}/v1/srmSfdCompeteHallRestful/doCloseCompeteHall`, /*  关闭竞价大厅，并更新数据到招标单据的报价单 */
    competeNotice_listCompeteNotice: `${_srmServer}/v1/srmSfdCompeteNoticeRestful/listCompeteNotice`, /*  查询竞价单消息表 */
    competeOfferHeader_listByPage: `${_srmServer}/v1/srmSfdCompeteOfferHeaderRestful/listByPage`, /*  查询竞价报价单列表 */
    competeOfferHeader_findById: `${_srmServer}/v1/srmSfdCompeteOfferHeaderRestful/findById`, /*  查询竞价报价单头明细 */
    competeOfferItem_listByPage: `${_srmServer}/v1/srmSfdCompeteOfferItemRestful/listByPage`, /*  查询竞价报价单行列表 */

    /* End 竞价单消息表 API列表 */

    /* Begin 竞价单竞价轮次信息表 API列表 */
    competeTurn_findById: `${_srmServer}/v1/srmSfdCompeteTurnRestful/findById`, /* 根据KEY ID查询竞价单竞价轮次信息表 */
    competeTurn_listByPage: `${_srmServer}/v1/srmSfdCompeteTurnRestful/listByPage`, /*  分页查询竞价单竞价轮次信息表 */
    competeTurn_saveOrUpdate: `${_srmServer}/v1/srmSfdCompeteTurnRestful/saveOrUpdate`, /*  保存竞价轮次信息 */
    competeTurnParam_listByPage: `${_srmServer}/v1/srmSfdCompeteTurnParamRestful/listByPage`, /*  分页查询竞价单竞价轮次信息参数表 */
    competeTurnParam_saveOrUpdate: `${_srmServer}/v1/srmSfdCompeteTurnParamRestful/saveOrUpdate`, /* 保存竞价单竞价轮次信息参数表 */
    /* End 竞价单竞价轮次信息表 API列表 */


    biddingDoc_doCreateCompete: `${_srmServer}/v1/srmSfdBiddingDocRestful/doCreateCompete`,  /* 招标创建竞价单 */
    biddingDoc_listByPageToCompete: `${_srmServer}/v1/srmSfdBiddingDocRestful/listByPageToCompete`,  /* 分页查询招标文件表（竞价） */

    slcApprovalProcessRestful_listByPage: `${srmServerUrl}/v1/srmSlcApprovalProcessRestful/listByPage`, /*  分页查询供应商注册审批表 */

    competeHeader_listByPage: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/listByPage`,  /* 分页查询竞价接口 */
    competeHeader_findById: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/findById`,  /* 根据ID，查询竞价接口 */
    competeHeader_delete: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/delete`,  /* 删除竞价接口 */
    competeHeader_saveOrUpdate: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/saveOrUpdate`,  /* 保存竞价接口 */
    competeHeader_doSubmit: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doSubmit`,  /* 提交竞价接口 */
    competeHeader_doReject: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doReject`,  /* 驳回竞价接口 */
    competeHeader_doApproval: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doApproval`,  /* 批准竞价接口 */
    competeHeader_doSaveAwardByItem: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doSaveAwardByItem`,  /* 保存竞价按物料中标的数据接口 */
    competeHeader_doSubmitByAward: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doSubmitByAward`,  /* 提交竞价决标数据接口 */
    competeHeader_doRejectByAward: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doRejectByAward`,  /* 驳回竞价决标数据接口 */
    competeHeader_doApprovalByAward: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doApprovalByAward`,  /* 批准竞价决标数据接口 */
    competeHeader_doOpenCompeteHall: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doOpenCompeteHall`,  /* 开启竞价大厅接口 */
    competeHeader_doCreateResult: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doCreateResult`,  /* 竞价创建结果接口 */
    competeHeader_doImportCompeteItem: `${_srmServer}/v1/srmSfdCompeteHeaderRestful/doImportCompeteItem`,  /* 竞价,批量导入标的物 */
    competeItem_listByPage: `${_srmServer}/v1/srmSfdCompeteItemRestful/listByPage`,  /* 分页查询竞价的物料接口 */
    competeItem_delete: `${_srmServer}/v1/srmSfdCompeteItemRestful/delete`,  /* 删除竞价的物料接口 */
    competeItem_listCompeteItemByAward: `${_srmServer}/v1/srmSfdCompeteItemRestful/listCompeteItemByAward`,  /* 竞价按物料定价汇总接口 */
    competeSupplier_listByPage: `${_srmServer}/v1/srmSfdCompeteSupplierRestful/listByPage`,  /* 分页查询竞价的供应商接口 */
    competeSupplier_delete: `${_srmServer}/v1/srmSfdCompeteSupplierRestful/delete`,  /* 删除竞价的供应商接口 */
    competeSupplier_doCompeteSupplierFeedback: `${_srmServer}/v1/srmSfdCompeteSupplierRestful/doCompeteSupplierFeedback`,  /* 供应商参与、拒绝竞价反馈 */

    /* Begin 资质审查头表 API列表 */
    slcQualifyHeader_findById: `${_srmServer}/v1/srmSlcQualifyHeaderRestful/findById`,/* 根据KEY ID查询资质审查头表 */
    slcQualifyHeader_listByPage: `${_srmServer}/v1/srmSlcQualifyHeaderRestful/listByPage`,  /* 供应商资质审查 */
    slcQualifyCategory_listByPage: `${_srmServer}/v1/srmSlcSupplierCategoriesRestful/listByPage`,  //分页查询供应商的采购分类
    slcQualifySite_listByPage: `${_srmServer}/v1/srmSlcQualifySiteRestful/listByPage`,/*  分页查询资质审查地点行表 */
    slcQualifyHeader_doApproval: `${_srmServer}/v1/srmSlcQualifyHeaderRestful/doQualifyApproval`,/* 审批资质审查单据 */
    slcQualifyHeader_doReject: `${_srmServer}/v1/srmSlcQualifyHeaderRestful/doQualifyReject`,/* 驳回资质审查单据 */
    /* End 资质审查头表 API列表 */

    /* Begin 供应商日常管理表 API列表 */
    srmSlcDailyManage_listByPage: `${srmServerUrl}/v1/srmSlcDailyManageRestful/listByPage`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_saveOrUpdate: `${srmServerUrl}/v1/srmSlcDailyManageRestful/saveOrUpdate`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_findById: `${srmServerUrl}/v1/srmSlcDailyManageRestful/findById`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_queryManageInfoById: `${srmServerUrl}/v1/srmSlcDailyManageRestful/queryManageInfoById`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_querySitesByLocationId: `${srmServerUrl}/v1/srmSlcDailyManageRestful/querySitesByLocationId`,  /* 日常管理查询接口（分页） */
    srmSlcDailyManage_doBatchSaveOrUpdate: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doBatchSaveOrUpdate`, /* 批量保存、更新供应商日常管理表 */
    srmSlcDailyManage_delete: `${srmServerUrl}/v1/srmSlcDailyManageRestful/delete`, /* 删除供应商日常管理表 */
    srmSlcDailyManage_doSubmit: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doDailyManageSubmit`,/* 审批日常管理单据 */
    srmSlcDailyManage_doApproval: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doDailyManageApproval`,/* 审批日常管理单据 */
    srmSlcDailyManage_doReject: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doDailyManageReject`,/* 驳回日常管理单据 */
    srmSlcDailyManage_doAbolish: `${srmServerUrl}/v1/srmSlcDailyManageRestful/doAbolish`,/* 作废日常管理单据 */
    /* End 供应商日常管理表 API列表 */

    /**供应商注册*/
    registerInfoRestful_getRegisterInfoVOById:`${srmServerUrl}/v1/srmSlcRegisterInfoRestful/getRegisterInfoVOById`,
    registerInfoRestful_listByPage:`${srmServerUrl}/v1/srmSlcRegisterInfoRestful/listByPage`,  //分页查询需审核的供应商的注册资料
    registerInfoRestful_listByPageManage:`${srmServerUrl}/v1/srmSlcRegisterInfoRestful/listByPageHead`,  //分页查询需领导审核的供应商的注册资料
    registerInfoRestful_getRegisterInfoVOByApprovalId:`${srmServerUrl}/v1/srmSlcRegisterInfoRestful/getRegisterInfoVOByApprovalId`,  //根据注册ID，获取供应商的注册资料
    baseOrganizationService_findPagination: `${_baseServer}/baseOrganizationService/findPagination`, // 根据用户数据权限查询组织信息
    registerInfoRestful_registerApproval:`${srmServerUrl}/v1/srmSlcRegisterInfoRestful/registerApproval`,  //批准或驳回供应商的注册资料
    registerInfoRestful_editRegisterApproval:`${srmServerUrl}/v1/srmSlcRegisterInfoRestful/editRegisterApproval`,  //修改一级审批人

    /**供应商变更*/
    changeInfoRestful_listByPage:`${srmServerUrl}/v1/srmSlcChangeInfoRestful/listSrmSlcChangeInfoInside`,  //分页查询供应商的变更单信息
    changeInfoRestful_findById:`${srmServerUrl}/v1/srmSlcChangeInfoRestful/findById`,  //根据变更ID，查询变更单信息
    supplierInfoRestful_querySupplierInfoById:`${srmServerUrl}/v1/srmSlcSupplierInfoRestful/querySupplierInfoById`,  //查询指定ID的供应商资料
    changeInfoRestful_reject:`${srmServerUrl}/v1/srmSlcChangeInfoRestful/rejectChangeInfo`,  //根据变更ID，驳回变更单信息
    changeInfoRestful_approval:`${srmServerUrl}/v1/srmSlcChangeInfoRestful/approvalChangeInfo`,  //根据变更ID，审批变更单信息
    changeInfoRestful_handOverBuyer: `${srmServerUrl}/v1/srmSlcChangeInfoRestful/handOverBuyer`, /* 移交至一级审批人审批*/

    /**招标文件发布*/
    biddingDoc_listByPageToPublish: `${srmServerUrl}/v1/srmSfdBiddingDocRestful/listByPageToPublish`,  /* 分页查询招标文件表（发标） */
    biddingDoc_findById: `${srmServerUrl}/v1/srmSfdBiddingDocRestful/findById`,  /* 根据ID，查询招标文件接口 */
    biddingPicketage_findById: `${srmServerUrl}/v1/srmSfdBiddingHeaderRestful/findById`,  /* 根据ID，查询招标文件接口 */
    srmSfdBiddingDocRestful_getDocCodeList: `${srmServerUrl}/v1/srmSfdBiddingDocRestful/getDocCodeList`,  /* 分页查询招标文件表（发标） */
    biddingPicketage_listBiddingDocPicketageDetail: `${srmServerUrl}/v1/srmSfdBiddingPicketageRestful/listBiddingDocPicketageDetail`,
    biddingPicketage_doTotalBiddingEvaluationScore: `${srmServerUrl}/v1/srmSfdBiddingScoreHeaderRestful/doTotalBiddingEvaluationScore`,
    respondHeader_findById: `${srmServerUrl}/v1/srmSfdRespondHeaderRestful/findById`,  /* 根据ID，查询供应商报价/商务谈判 */
    respondItem_listByPage: `${srmServerUrl}/v1/srmSfdRespondItemRestful/listByPage`,  /* 分页查询供应商报价行 */
    biddingJury_listByPage: `${srmServerUrl}/v1/srmSfdBiddingJuryRestful/listByPage`,  /* 获取评标小组信息 */
    biddingDoc_doRejectPublish: `${srmServerUrl}/v1/srmSfdBiddingDocRestful/doRejectPublish`,  /* 驳回发标接口 */
    biddingDoc_doApprovalPublish: `${srmServerUrl}/v1/srmSfdBiddingDocRestful/doApprovalPublish`,  /* 审批发标接口 */
    biddingDoc_srmSfdListItem_listByPage: `${srmServerUrl}/v1/srmSfdListItemRestful/listByPage`,  /* 审批发标接口 */
    biddingDoc_srmSfdBiddingShortlist: `${srmServerUrl}/v1/srmSfdBiddingShortlistRestful/findById`,  /* 审批发标接口 */


    /***/
    cctAcceptLogRestful_listByPage: `${_srmServer}/v1/srmCctAcceptLogRestful/listByPage`,  /* 验收日志 */
    cctAcceptLogRestful_receiveAccept: `${_srmServer}/v1/srmCctAcceptLogRestful/receiveAccept`,  /* 验收操作 */
    cctCommissioningAcceptanceRestful_findById: `${_srmServer}/v1/srmCctCommissioningAcceptanceRestful/findById`,  /* 安装调试验收单详情 */
    cctCommissioningAcceptanceRestful_listByPage: `${_srmServer}/v1/srmCctCommissioningAcceptanceRestful/listByPage`,  /* 安装调试验收单列表 */
    cctReceiptHeaderRestful_findById: `${_srmServer}/v1/srmCctReceiptHeaderRestful/findById`,  /* 到货验收单详情 */
    cctReceiptHeaderRestful_listByPage: `${_srmServer}/v1/srmCctReceiptHeaderRestful/listByPage`,  /* 到货验收单列表 */
    cctReceiptLineRestful_listByPage: `${_srmServer}/v1/srmCctReceiptLineRestful/listByPage`,  /* 到货验收单列表 */

    /**消息管理API开始*/
    srmBaseImRoomRestful_findById: `${_baseServer}/v1/srmBaseImRoomRestful/findById`,
    srmBaseImRoomRestful_saveOrUpdate: `${_baseServer}/v1/srmBaseImRoomRestful/saveOrUpdate`,
    srmBaseImRoomUserRestful_delete: `${_baseServer}/v1/srmBaseImRoomUserRestful/delete`, /**删除用户,退出群聊*/
    srmBaseImRoomUserRestful_listByPage: `${_baseServer}/v1/srmBaseImRoomUserRestful/listByPage`,
    srmBaseImRoomUserRestful_doBatchSaveOrUpdate: `${_baseServer}/v1/srmBaseImRoomUserRestful/doBatchSaveOrUpdate`,
    srmBaseImRoomUserRestful_getRoomUserUnreadCount: `${_baseServer}/v1/srmBaseImRoomUserRestful/getRoomUserUnreadCount`,
    /**消息管理API结束 */

    /** BPM 开始**/
    bpmRestful_findTodoTasks: `${bpmServer}/bpmTaskService/findTodoTasks`,  /*我的待审批流程查询*/
    bpmRestful_findBpmLists: `${bpmServer}/bpmListService/findBpmLists`,  /*我提交的流程查询*/
    bpmRestful_findHistoricTasks: `${bpmServer}/bpmHistoryService/findHistoricTasks`,  /*我的已审批流程查询*/
    findNotifyTasks: `${bpmServer}/bpmNotifyTaskService/findNotifyTasks`,//待阅
    bpmRestful_processGetTaskUrl: `${bpmServer}/bpmProcessService/getTaskUrl`,   /*获取审批页面URL*/
    bpmTaskService_complete: `${bpmServer}/bpmTaskService/complete`,// 驳回
    // bpmServer/bpmListService/getBpmListByParam
    bpmListService_getBpmListByParam: `${bpmServer}/bpmListService/getBpmListByParam`,  /*查询流程*/

    // 价格申请
    purPriceApply_listByPage: `${srmServerUrl}/v1/srmPurPriceApplyHeaderRestful/listByPage`,  /* 分页查询价格申请 */
    purPriceApply_history: `${bpmServer}/bpmHistoryService/findHistoricActivities`,  /* 查询审批历史 */
    purPriceApply_detail: `${srmServerUrl}/v1/srmPurPriceApplyLineRestful/listByPage`,  /* 物料详情 */
    purPriceApply_findById: `${srmServerUrl}/v1/srmPurPriceApplyHeaderRestful/findById`,

    purPriceApply_transfer: `${bpmServer}/bpmTaskService/doPersonalTaskTransfer`,  /* 转办 */
    purPriceApply_batch: `${bpmServer}/bpmNotifyTaskService/doBatchSave`,  /* 传阅 */
    purPriceApply_staffPersonData: `${_baseServer}/baseUsersService/findInternalUsers`,  /* 获取转办待阅人员数据 */

    // 询价定价
    fixedPrice_bidFileVOList: `${srmServerUrl}/v1/srmSfdBidItemRestful/bidFileVOList`,
    auctionHeaderRestful_findById: `${srmServerUrl}/v1/srmSfdAuctionHeaderRestful/findById`,
    srmSfdBidItem_fixPriceList: `${srmServerUrl}/v1/srmSfdBidItemRestful/fixPriceList`,
    srmBaseExchangeRate_getUsdToCny: `${srmServerUrl}/v1/srmBaseExchangeRateRestful/getUsdToCny`,
    bidHeaderRestful_findById: `${srmServerUrl}/v1/srmSfdBidHeaderRestful/findById`,
    bidItemRestful_listSfdBidItem: `${srmServerUrl}/v1/srmSfdBidItemRestful/listSfdBidItem`,

    // 竞价定价
    bidding_findById: `${srmServerUrl}/v1/srmSfdCompeteHeaderRestful/findById`,
    bidding_listFixPrice: `${srmServerUrl}/v1/srmSfdCompeteItemRestful/listFixPrice`,

    // 供应商状态变更
    slcSupplierStatusChange_findById: `${srmServerUrl}/v1/srmSlcSupplierStatusChangeRestful/findById`,
    srmSlcSupplierStatusChange_findById: `${srmServerUrl}/v1/srmSlcSupplierStatusChangeRestful/findById`,
    // 现场考察
    srmSlcLocaleInspectRestful_findById: `${srmServerUrl}/v1/srmSlcLocaleInspectRestful/findById`,
    // 合格供应商申请
    srmSlcQualifiedSupplierRestful_findById: `${srmServerUrl}/v1/srmSlcQualifiedSupplierRestful/findById`,
    // 合格供应商申请
    srmSlcQualifiedSupplierRestful_getQualifiedInfo: `${srmServerUrl}/v1/srmSlcQualifiedSupplierRestful/getQualifiedInfo`,
    // 内部注册
    srmSlcSupplierInsideCreateRestful_querySupplierInfoById: `${srmServerUrl}/v1/srmSlcSupplierInsideCreateRestful/querySupplierInfoById`,

    // 合同模板审批详情
    cctHtmbDetail_findById: `${srmServerUrl}/v1/srmCctTemplateRestful/findById`,
    // 合同模板审批详情附件
    cctHtmbDetailAttaRestful_listByPage: `${srmServerUrl}/v1/srmCctTemplateAttaRestful/listByPage`,

    // 合同用印审批
    cctUseApprovalRestful_findById: `${srmServerUrl}/v1/srmCctContractRestful/findById`,
    // 合同用印审批付款比例
    cctPaymentStageRestful_contractUpdateDetail: `${srmServerUrl}/v1/srmCctPaymentStageRestful/contractUpdateDetail`,
    // 合同用印审批合同文本
    cctPaymentStageRestful_contractDocument: `${srmServerUrl}/v1/srmCctContractDocumentRestful/contractUpdateDetail`,
    // 合同用印审批合同归档
    cctPaymentStageRestful_contractArchive: `${srmServerUrl}/v1/srmCctContractArchiveRestful/contractUpdateDetail`,
    // 合同用印审批合同交易方
    cctPaymentStageRestful_contractTrade: `${srmServerUrl}/v1/srmCctContractTradeRestful/contractUpdateDetail`,
    // 合同用印审批合同关联合同
    cctPaymentStageRestful_contractRelated: `${srmServerUrl}/v1/srmCctContractItemRestful/contractUpdateDetail`,

    // 采购订单审批详情
    purOrderDetail_findById: `${srmServerUrl}/v1/srmPurOrderHeaderRestful/findById`,
    // 采购订单审批详情物料明细
    purOrderLineRestful_listByPage: `${srmServerUrl}/v1/srmPurOrderLineRestful/listByPage`,


    // 非生收货单审批详情
    purConsigneeDetail_findById: `${srmServerUrl}/v1/srmPurConsigneeHeaderRestful/findById`,
    // 非生收货单收货明细
    purConsigneeDetailRestful_listByPage: `${srmServerUrl}/v1/srmPurConsigneeLineRestful/listByPage`,

    // 非生采购申请审批详情
    purApplyDetail_findById: `${srmServerUrl}/v1/srmPurRequisitionHeaderRestful/findById`,
    // 非生采购申请审批详情物料明细
    purApplyLineRestful_listByPage: `${srmServerUrl}/v1/srmPurRequisitionLineRestful/list`,

    // 8D报告审批详情
    qcn8dReportDetail_findById: `${srmServerUrl}/v1/srmQcnReportHeaderRestful/findById`,
    // 8D报告审批详情团队成员
    qcn8dReportTeamRestful_listByPage: `${srmServerUrl}/v1/srmQcnReportTeamRestful/listByPage`,
    // 8D报告审批详情围堵对策
    qcn8ReportContainRestful_listByPage: `${srmServerUrl}/v1/srmQcnReportContainRestful/listByPage`,
    // 8D报告审批详情纠正对策
    qcn8dReportRemedialRestful_listByPage: `${srmServerUrl}/v1/srmQcnReportRemedialRestful/listByPage`,
    // 8D报告审批详情验证结果
    qcn8dReportVerificationRestful_listByPage: `${srmServerUrl}/v1/srmQcnReportVerificationRestful/listByPage`,
    // 8D报告审批详情团队及小组成员认可
    qcn8dReportGroupRestful_listByPage: `${srmServerUrl}/v1/srmQcnReportGroupRestful/listByPage`,

    // 定损审批详情
    qcnLossAssessmentDetail_findById: `${srmServerUrl}/v1/srmQcnLossAssessmentRestful/findById`,
    // 定损明细行
    qcnLossAssessmentDetailAttaRestful_listByPage: `${srmServerUrl}/v1/srmQcnLossAssessmentLineRestful/listByPage`,

    // 索赔单审批详情
    qcnClaimHeaderDetail_findById: `${srmServerUrl}/v1/srmQcnClaimHeaderRestful/findById`,
    // 索赔单明细行
    qcnClaimHeaderDetailAttaRestful_listByPage: `${srmServerUrl}/v1/srmQcnClaimLineRestful/listByPage`,

    // 非生结算单审批详情
    rcnSettlementDetail_findById: `${srmServerUrl}/v1/srmRcnSettlementHeaderRestful/findById`,
    // 非生结算单明细
    rcnSettlementDetailAttaRestful_listByPage: `${srmServerUrl}/v1/srmRcnSettlementLineRestful/listByPage`,
    // 非生结算单发票明细
    rcnSettlementDetailInvoiceRestful_listByPage: `${srmServerUrl}/v1/srmRcnSettlementInvoiceLineRestful/listByPage`,

    // 预付款申请审批详情
    payRequestYfkDetail_findById: `${srmServerUrl}/v1/srmRcnAdvanceApplyRestful/findById`,

    // 预付款申请审批详情付款单明细
    srmRcnArrivalPaymentRestful_listByPage: `${srmServerUrl}/v1/srmRcnArrivalPaymentRestful/findById`,

    // 付款申请审批详情
    payRequestFsfkDetail_findById: `${srmServerUrl}/v1/srmRcnNonProductionApplyRestful/findById`,

    // 模具主数据审批详情
    mdmMoulds_findById: `${srmServerUrl}/v1/srmMdmMouldsRestful/findById`, /* 根据KEY ID查询模具台账表 */
    bpmTaskService_revoke: `${bpmServer}/bpmTaskService/revoke`,/* 撤回 */
    bpmTaskService_doPersonalTaskTransfer: `${bpmServer}/bpmTaskService/doPersonalTaskTransfer`,/* 转办 */

    // 模具变更审批详情
    srmMdmChanges_findById: `${srmServerUrl}/v1/srmMdmChangesRestful/findById`, /* 根据KEY ID查询模具变更表 */
    srmMdmMouldChangeAccept_listByPage: `${srmServerUrl}/v1/srmMdmMouldChangeAcceptRestful/listByPage`, /*  分页查询模具验收表变更表 */

    // 模具报废审批详情
    mdmScraps_findById: `${srmServerUrl}/v1/srmMdmScrapsRestful/findById`, /* 根据KEY ID查询模具报废单表 */

    // 模具验收审批详情
    mdmInspections_findById: `${srmServerUrl}/v1/srmMdmInspectionsRestful/findById`, /* 根据KEY ID查询模具验收表 */

    // 合同模板审批详情
    srmCctTemplate_findById: `${srmServerUrl}/v1/srmCctTemplateRestful/findById`, /* 根据KEY ID查询合同模板 */
    srmCctTemplateAtta_listByPage: `${srmServerUrl}/v1/srmCctTemplateAttaRestful/listByPage`, /*  分页查询合同模板附件 */

    // 合同管理审批详情
    srmCctContract_findById: `${srmServerUrl}/v1/srmCctContractRestful/findById`, /* 根据KEY ID查询合同信息 */
    srmCctPaymentStage_contractUpdateDetail: `${srmServerUrl}/v1/srmCctPaymentStageRestful/contractUpdateDetail`, /*  分页查询付款阶段 */
    srmCctContractDocument_contractUpdateDetail: `${srmServerUrl}/v1/srmCctContractDocumentRestful/contractUpdateDetail`, /*  分页查询合同文本 */
    srmCctContractArchive_contractUpdateDetail: `${srmServerUrl}/v1/srmCctContractArchiveRestful/contractUpdateDetail`, /*  分页查询归档附件 */
    srmCctContractItem_contractUpdateDetail: `${srmServerUrl}/v1/srmCctContractItemRestful/contractUpdateDetail`, /*  分页查询标的物 */
    srmCctContractSeal_listByPage: `${srmServerUrl}/v1/srmCctContractSealRestful/listByPage`, /*  分页查询用印方表 */
    srmCctContract_listNoPermissionByPage: `${srmServerUrl}/v1/srmCctContractRestful/listNoPermissionByPage`, /*  分页查询合同信息 */

    //资质审查审批详情
    srmSlcQualifyHeader_findById: `${srmServerUrl}/v1/srmSlcQualifyHeaderRestful/findById`,/* 根据KEY ID查询资质审查头表 */

    // 实地评鉴（与 PC 一致）
    localeInspect_listByPage: `${srmServerUrl}/v1/srmSlcLocaleInspectRestful/listByPage`,  /* 现场考察查询接口（分页） */
    localeInspect_findById: `${srmServerUrl}/v1/srmSlcLocaleInspectRestful/findById`,  /* 根据ID，查询现场考察信息接口 */
    inspectRecord_doBatchSaveOrUpdate: `${srmServerUrl}/v1/srmSlcInspectRecordRestful/doBatchSaveOrUpdate`,  /* 批量更新现场考察记录 */
    inspectCategories_listByPage: `${srmServerUrl}/v1/srmSlcInspectCategoriesRestful/listByPage`,  /* 查询考察计划的采购分类接口（分页） */

    //样品评估审批详情
    sampleTrial_findById: `${srmServerUrl}/v1/srmSlcSampleTrialRestful/findById`,  /* 根据ID，查询样品试验信息 */
    inspectCategories_listSlcInspectCategories: `${srmServerUrl}/v1/srmSlcInspectCategoriesRestful/listSlcInspectCategories`,  /* 查询考察计划的采购分类） */

    // 附加费用审批详情
    srmPurAdditionalFeeHeader_findById: `${srmServerUrl}/v1/srmRcnAdditionalFeeHeaderRestful/findById`,
    srmPurAdditionalFeeHeader_listByPage: `${srmServerUrl}/v1/srmRcnAdditionalFeeHeaderRestful/listByPage`,
    srmPurAdditionalFeeHeader_saveOrUpdate: `${srmServerUrl}/v1/srmRcnAdditionalFeeHeaderRestful/saveOrUpdate`,
    srmPurAdditionalFeeLine_listByPage: `${srmServerUrl}/v1/srmRcnAdditionalFeeLineRestful/listByPage`,

    /** 对账单（与 PC 一致） */
    accountStmt_listByPage: `${srmServerUrl}/v1/srmRcnAccountStmtRestful/listByPage`,
    accountStmt_findById: `${srmServerUrl}/v1/srmRcnAccountStmtRestful/findById`,
    accountStmt_doReject: `${srmServerUrl}/v1/srmRcnAccountStmtRestful/doReject`,
    accountStmt_doApproval: `${srmServerUrl}/v1/srmRcnAccountStmtRestful/doApproval`,
    accountStmtLine_listRcnAccountStmtLine: `${srmServerUrl}/v1/srmRcnAccountStmtLineRestful/listRcnAccountStmtLine`,
    srmRcnAccountStmtDe_list: `${srmServerUrl}/v1/srmRcnAccountStmtDeRestful/list`,
    srmRcnAccountStmtDiscount_list: `${srmServerUrl}/v1/srmRcnAccountStmtDiscountRestful/list`,
    srmRcnAccountStmtAdditional_list: `${srmServerUrl}/v1/srmRcnAccountStmtAdditionalRestful/list`,
    srmRcnAccountStmtPrepay_list: `${srmServerUrl}/v1/srmRcnAccountStmtPrepayRestful/list`,
    srmBaseAccountingBusinessDept_listByPage: `${srmServerUrl}/v1/srmBaseAccountingBusinessDeptRestful/listByPage`,

    /** 绩效评分审批（PC SrmSpeSchemeScoreEdit） */
    srmSpeSchemeScore_findById: `${srmServerUrl}/v1/srmSpeSchemeScoreRestful/findById`,
    srmSpeSupplierScore_findPageListBySchemeScoreId: `${srmServerUrl}/v1/srmSpeSupplierScoreRestful/findPageListBySchemeScoreId`,
    /** 绩效评分汇总审批（PC SrmSpeSchemeScoreTotalEdit） */
    srmSpeSchemeScoreTotalFlowHead_findById: `${srmServerUrl}/v1/srmSpeSchemeScoreTotalFlowHeadRestful/findById`,
    srmSpeSchemeScoreTotalFlowHead_listScoreCommentDetail: `${srmServerUrl}/v1/srmSpeSchemeScoreTotalFlowHeadRestful/listScoreCommentDetail`,
    srmSpeSchemeScoreTotalFlowHead_listDimensions: `${srmServerUrl}/v1/srmSpeSchemeScoreTotalFlowHeadRestful/listDimensions`,
}

export default api;



// WEBPACK FOOTER //
// ./src/page/srm/config/api.js